import { makeStyles, Slider, withStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles({
  root: {
    height: 258
  }
})

const CustomSlider = withStyles({
  root: {},
  markLabel: {
    opacity: 0.8,
    color: '#fff',
    border: '1px solid #999',
    width: 50,
    height: 26,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  markLabelActive: {
    opacity: 1,
    border: '1px solid #fff',
    color: '#fff'
  }
})(Slider)

interface SnellenSliderProps {
  handleChange?: (name: string, value: number) => void
  name: string
}

const Snellen: React.FC<SnellenSliderProps> = ({ handleChange, name }) => {
  const classes = useStyles()

  const min = 0
  const max = 7
  const marks = [
    {
      value: 7,
      label: '20/200'
    },
    {
      value: 6,
      label: '20/100'
    },
    {
      value: 5,
      label: '20/70'
    },
    {
      value: 4,
      label: '20/50'
    },
    {
      value: 3,
      label: '20/40'
    },
    {
      value: 2,
      label: '20/30'
    },
    {
      value: 1,
      label: '20/25'
    },
    {
      value: 0,
      label: '20/20'
    }
  ]

  const change = (value: number) => {
    if (handleChange) {
      const values = [0, 2, 2.5, 3, 3.5, 5, 6, 7]
      handleChange(name, values[value])
    }
  }

  return (
    <div className={classes.root}>
      <CustomSlider
        orientation="vertical"
        aria-labelledby="vertical-slider"
        id="teste"
        onChange={(_, value) => {
          change(Number(value))
        }}
        defaultValue={0}
        min={min}
        max={max}
        marks={marks}
        step={1}
      />
    </div>
  )
}

export default Snellen
